import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "BrowserStack – a less painful way to test weird browsers",
  "description": "",
  "published": "2019-03-20T00:00:00.000Z",
  "redirect_from": ["/blog/browserstack-a-less-painful-way-to-test-weird-browsers/swizec/8992"],
  "categories": "Front End, Technical",
  "hero": "./img/o9Z0rYC.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`When was the last time you had to make sure your app works on weird browsers like Microsoft Edge?`}</p>
    <p>{`Me, I had to do it earlier this week. My experience building websites for a web agency back in high school meant I knew what I was getting into.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Client: Hey can you make it work on Edge?`}<br parentName="p"></br><br parentName="p"></br>{`and here I was thinking I could go to bed early tonight `}<a parentName="p" {...{
          "href": "https://t.co/oBqRKe6VYz"
        }}>{`pic.twitter.com/oBqRKe6VYz`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1107895195163451393"
      }}>{`March 19, 2019`}</a></blockquote>
    <p><img parentName="p" {...{
        "src": "/84df238d7ffd339fcecd88936052e891/media-116a8zosxwA0SI-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`Microsoft Edge did not disappoint.`}</p>
    <p><inlineCode parentName="p">{`Array.flat()`}</inlineCode>{` doesn't work on Edge. On `}<em parentName="p">{`every other browser`}</em>{` it flattens nested arrays. On Edge it blows up and says the method doesn't exist.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/c80f1f30d944c5aac0bfba95f4b6d032/2e92a/o9Z0rYC.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "14.349775784753364%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'57\\'%20viewBox=\\'0%200%20400%2057\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M131%2015v6h23V10h-23v5m-77%202v4h23v-9H54v5m26%200v4h23v-9H80v5M3%2027v6l-1%206%201%205h396V22h-13v10h-28V22h-23v10h-54V22h-23v5l-1%205-1-5v-5h-23v5l-1%205c-2%200-2-1-2-5v-5h-23v5l1%205h-29V22h-23v5l1%205h-29V22h-23v5l1%205H52V22H29v5l-1%205c-2%200-2-1-2-5v-5H3v5m52%200l-1%204h23v-9H55v5m25%200v4h22v-9H80v5m51%200v4h22v-9h-22v5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c80f1f30d944c5aac0bfba95f4b6d032/ca0a1/o9Z0rYC.webp 223w", "/static/c80f1f30d944c5aac0bfba95f4b6d032/75680/o9Z0rYC.webp 445w", "/static/c80f1f30d944c5aac0bfba95f4b6d032/8d1ba/o9Z0rYC.webp 890w", "/static/c80f1f30d944c5aac0bfba95f4b6d032/3838e/o9Z0rYC.webp 1335w", "/static/c80f1f30d944c5aac0bfba95f4b6d032/e11e5/o9Z0rYC.webp 1780w", "/static/c80f1f30d944c5aac0bfba95f4b6d032/1f744/o9Z0rYC.webp 2508w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c80f1f30d944c5aac0bfba95f4b6d032/e92b6/o9Z0rYC.png 223w", "/static/c80f1f30d944c5aac0bfba95f4b6d032/e66bf/o9Z0rYC.png 445w", "/static/c80f1f30d944c5aac0bfba95f4b6d032/4ef49/o9Z0rYC.png 890w", "/static/c80f1f30d944c5aac0bfba95f4b6d032/4e814/o9Z0rYC.png 1335w", "/static/c80f1f30d944c5aac0bfba95f4b6d032/701e9/o9Z0rYC.png 1780w", "/static/c80f1f30d944c5aac0bfba95f4b6d032/2e92a/o9Z0rYC.png 2508w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c80f1f30d944c5aac0bfba95f4b6d032/4ef49/o9Z0rYC.png",
                "alt": "CanIuse for Array.flat",
                "title": "CanIuse for Array.flat",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`CanIuse for Array.flat`}</figcaption>{`
  `}</figure></p>
    <p>{`CanIuse for Array.flat`}</p>
    <p>{`Okay not `}<em parentName="p">{`every`}</em>{` browser. Only the ones that people use.`}</p>
    <p>{`You can solve that with a polyfill right? An npm package that loads itself up and makes Array.flat work.`}</p>
    <p>{`Yep, makes the error go away. Doesn't behave the way it does on other browsers. 🤦‍♂️`}</p>
    <p>{`So I had to replace every `}<inlineCode parentName="p">{`.flat()`}</inlineCode>{` with my own hack like this: `}<inlineCode parentName="p">{`.reduce((arr, vals) => [...arr, ...vals], [])`}</inlineCode>{`. Sigh`}</p>
    <p>{`In this project I was also using `}<a parentName="p" {...{
        "href": "https://gka.github.io/chroma.js/"
      }}>{`chroma-js`}</a>{` to manipulate colors. Convenient way to take a color and give it a little alpha channel with `}<inlineCode parentName="p">{`chroma(color).alpha(0.5)`}</inlineCode>{`.`}</p>
    <p>{`Except on Edge this created invalid hex values. Colors no work at all.`}</p>
    <p>{`Had to hack it together like this `}<inlineCode parentName="p">{` \`rgba(\${chroma(color).alpha(0.5).rgba().join(',')})`}</inlineCode></p>
    <p>{`🤨`}</p>
    <p>{`You thought that was bad? It gets even better!`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Oh also on Edge node.getBoundingClientRect() doesn't return a DOMRect. Oh no, it returns a ClientRect.`}<br parentName="p"></br><br parentName="p"></br>{`Unlike DOMRect, ClientRect (which exists only on Edge) doesn't have x and y coordinates. Only top and left`}<br parentName="p"></br><br parentName="p"></br>{`🤨`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1107905401276624900"
      }}>{`March 19, 2019`}</a></blockquote>
    <p><inlineCode parentName="p">{`.getBoundingClientRect()`}</inlineCode>{` doesn't work on Edge. Well it does but it returns a `}<inlineCode parentName="p">{`ClientRect`}</inlineCode>{` instead of a `}<inlineCode parentName="p">{`DOMRect`}</inlineCode>{`. They work the same except when they don't.`}</p>
    <p>{`For example DOMRect has `}<inlineCode parentName="p">{`x`}</inlineCode>{` and `}<inlineCode parentName="p">{`y`}</inlineCode>{` coordinates. `}<inlineCode parentName="p">{`ClientRect`}</inlineCode>{` only has `}<inlineCode parentName="p">{`top`}</inlineCode>{` and `}<inlineCode parentName="p">{`left`}</inlineCode>{`. Oh and ClientRect only exists on Edge. Of course.`}</p>
    <p>{`This meant I had to fix my `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useDimensions"
      }}><inlineCode parentName="a">{`useDimensions`}</inlineCode></a>{` library. Project relies on it a lot to measure stuff and build responsive data visualizations.`}</p>
    <p>{`Oh and flexbox doesn't work correctly. Instead of spacing evenly it bunches everything on the left. Of course.`}</p>
    <p><img parentName="p" {...{
        "src": "/c6ffc0b3ef1674e39e4b33dc162c6743/media-26ufcVAp3AiJJsrIs-giphy.gif",
        "alt": null
      }}></img></p>
    <h2 {...{
      "id": "the-hero-in-this-story-is-browserstack"
    }}>{`The hero in this story is BrowserStack`}</h2>
    <p>{`Despite all this pain, there is a silver lining 👉 `}<a parentName="p" {...{
        "href": "https://www.browserstack.com/"
      }}>{`BrowserStack`}</a>{` made testing on Microsoft Edge absolutely painless.`}</p>
    <p>{`Well the testing itself was painful and the results made me cry but `}<em parentName="p">{`I could test`}</em>{`.`}</p>
    <p>{`I'm a Mac kind of guy you see. I don't have Edge. I don't have a Windows machine. I have zero interest in VirtualBox and futzing around with images and installing Windows on a partition and whatever else it used to take to test on weird browsers.`}</p>
    <p>{`With BrowserStack I was able to run Edge in a Chrome tab. That's right. A Chrome tab emulated an entire operating system running a full screen browser.`}</p>
    <p>{`Edge probably runs on their servers and streams an image to the tab. Still, feels like magic.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/58d34201f48a0aab1c2509b10f092418/a3a74/lGhiEHR.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "55.15695067264574%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'220\\'%20viewBox=\\'0%200%20400%20220\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20110v110h401V0H0v110m24-51v33h69v9H24v99h62l180%201h118v-7a33199%2033199%200%20000-130V26H24v33\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/58d34201f48a0aab1c2509b10f092418/ca0a1/lGhiEHR.webp 223w", "/static/58d34201f48a0aab1c2509b10f092418/75680/lGhiEHR.webp 445w", "/static/58d34201f48a0aab1c2509b10f092418/8d1ba/lGhiEHR.webp 890w", "/static/58d34201f48a0aab1c2509b10f092418/3838e/lGhiEHR.webp 1335w", "/static/58d34201f48a0aab1c2509b10f092418/e11e5/lGhiEHR.webp 1780w", "/static/58d34201f48a0aab1c2509b10f092418/d3f94/lGhiEHR.webp 2272w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/58d34201f48a0aab1c2509b10f092418/e92b6/lGhiEHR.png 223w", "/static/58d34201f48a0aab1c2509b10f092418/e66bf/lGhiEHR.png 445w", "/static/58d34201f48a0aab1c2509b10f092418/4ef49/lGhiEHR.png 890w", "/static/58d34201f48a0aab1c2509b10f092418/4e814/lGhiEHR.png 1335w", "/static/58d34201f48a0aab1c2509b10f092418/701e9/lGhiEHR.png 1780w", "/static/58d34201f48a0aab1c2509b10f092418/a3a74/lGhiEHR.png 2272w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/58d34201f48a0aab1c2509b10f092418/4ef49/lGhiEHR.png",
                "alt": "BrowserStack open screen",
                "title": "BrowserStack open screen",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`BrowserStack open screen`}</figcaption>{`
  `}</figure></p>
    <p>{`BrowserStack open screen`}</p>
    <p>{`BrowserStack really does support all browsers 👌`}</p>
    <p>{`You can use it for free for 15 minutes I think. I needed more so I ponied up a whopping $19 for a freelancer plan. That gave me 100 minutes.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f40727dd1d1d683b3cd4477a7ed0e8ba/8b936/GqIcx7k.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.02242152466367%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'261\\'%20viewBox=\\'0%200%20400%20261\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20131v130h401V0H0v131M73%206a529%20529%200%200048%209l9%201%202%202%203%201%202%202h2c1-2%206-3%208%200%202%201%202%203%201%203l-1-1-4-1c-6%200-5%202%201%203%203%200%205%200%204%201l1%201h2c1-1%203-1%203%202%200%201-5%202-5%200h-1c0%202%201%202%204%202l3-1%201-2c1%200%202%202%202%208%201%202%201%203%205%203l5%201h1l3%201%201%202h1l-1%202-1%202c-3-1-6%202-6%205%200%202%200%202-3%202l-4-1c0-1%201-2%203-2l3-1-3-1-3-1c0-2%201-2%204-2l3-1-5-1h-3l-1%206v6h4l5-1h1l5%201h3v-7c0-9%201-7%201%202%200%206%201%207%202%208%203%201%206%200%207-4%200-1%200-2%201-1v2h4c6%200%208%202%206%206-2%203-2%203-1%204s-5%201-14%201c-11%200-12%201-6%201%2014%200%2015%201%2010%203-8%204-13%2010-17%2020-3%207-2%207%204%201l9-6c3-2%2014-4%2015-4%201%202%201%204-3%206l-3%204c1%202%200%202-2%202s-3-1%200-6c2-3%202-5-1-3l-2%201c0-1-7%206-9%2011-3%206-3%2017%202%2023%206%209%2017%2013%2029%2011%2010-2%2012-3%2012-8v-4l21%201a7375%207375%200%2000128%204h32V18h-3a3118%203118%200%2000-68-10l-8%201-9%203c-4%202-24%201-39-2l-14-1a651%20651%200%2001-44-3l-6%201v4c0%203%200%204-1%203h-1c0%202-1%202-3%201-2%200-3%200-3%202l-6%201a571%20571%200%2000-43-5C74%204%2056%202%2073%206m262%20126l-65%202a375%20375%200%2000-69%205c-3%200-3%201-2%204l-1%203-2%202c0%202%201%203%203%201%202-3%206-2%206%200h-1c-1-1-1%200-1%204%200%206-1%208-5%208l-4%201h-1l-5-1c-5%200-5%200-5%203s2%204%204%203h5c1-2%202-2%202-1l4%201c2%200%203%200%202%201-4%201%201%203%207%203h6v22c-2%201-5%204-6%207%200%205-2%206-8%206-3%200-4%200-3%202l-1%201-2%201h-3l15%201c14%200%2012%201-14%201h-31v5l-1%206v2c-2%200-5%203-8%206l-10%207c-11%203%202%204%2020%201l39-1c29%200%2034%200%2035-2h2l-1%201v2a215%20215%200%200058-2c3-2%2016-4%2017-2l8%202%209%201%203-1c2-1%204-1%205%201h4c3%200%204%200%204%202l3%201%206-1%203-1h-3l-4-1v-2l12-1a210%20210%200%200021%200h6c-3%201-3%201%201%201l4-1%204-1%203-1-1-1v-3l1-48v-49h-18a1037%201037%200%2001-47%200m-209%2028c0%202%201%204%203%204l1%201-2%201h-2c0%201%202%202%204%201h4l3-1h1l5%201c4%200%205%200%205-2l1-2v2c0%202%202%203%202%201%201-1%201%200%201%201%200%202%205%203%205%201l1-2c0-4-3-7-6-4h-1l-2-1-3-1h-5l-3%201h-2l-3%201c-1%202-2%202-3%200-2-1-2-1%200-1l2-1c-1-2-5-1-6%200m36%2056v6c0%202%200%203%201%202%200-2%201-2%205-2l4-1%204-2%204-3%2010-1c17%200%2011-1-9-1-18%200-20%200-19%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f40727dd1d1d683b3cd4477a7ed0e8ba/ca0a1/GqIcx7k.webp 223w", "/static/f40727dd1d1d683b3cd4477a7ed0e8ba/75680/GqIcx7k.webp 445w", "/static/f40727dd1d1d683b3cd4477a7ed0e8ba/8d1ba/GqIcx7k.webp 890w", "/static/f40727dd1d1d683b3cd4477a7ed0e8ba/3838e/GqIcx7k.webp 1335w", "/static/f40727dd1d1d683b3cd4477a7ed0e8ba/338ac/GqIcx7k.webp 1368w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f40727dd1d1d683b3cd4477a7ed0e8ba/e92b6/GqIcx7k.png 223w", "/static/f40727dd1d1d683b3cd4477a7ed0e8ba/e66bf/GqIcx7k.png 445w", "/static/f40727dd1d1d683b3cd4477a7ed0e8ba/4ef49/GqIcx7k.png 890w", "/static/f40727dd1d1d683b3cd4477a7ed0e8ba/4e814/GqIcx7k.png 1335w", "/static/f40727dd1d1d683b3cd4477a7ed0e8ba/8b936/GqIcx7k.png 1368w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/f40727dd1d1d683b3cd4477a7ed0e8ba/4ef49/GqIcx7k.png",
              "alt": "GqIcx7k",
              "title": "GqIcx7k",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`You can even run things from localhost. No idea how they made that work. Type `}<inlineCode parentName="p">{`http://localhost:3000`}</inlineCode>{` into the URL bar and it actually goes to your localhost.`}</p>
    <p>{`Just don't type `}<inlineCode parentName="p">{`localhost:3000`}</inlineCode>{` because Edge doesn't know how to deal with that and says it can't reach the URL. 🤦‍♂️`}</p>
    <p>{`And here's proof. Edge running inside Chrome showing my homepage.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/e6c6a6c094162369c4feb0d6d39af7bf/adef7/9yvIsIG.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "79.82062780269058%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'319\\'%20viewBox=\\'0%200%20400%20319\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%204c-2%202%200%203%206%203%203%201%204%200%204-1h1c1%203%2014%202%2014-1%200-1-1-2-9-2h-9c-2-1-6-1-7%201m126%201l1%203h11c8%200%2013-1%2013-2l3%201h5V4l-2-1h-28c-1-2-3-1-3%202M0%2014c0%203%200%203%203%203s3%200%202%202v4c2%201%205%201%205-2%200-2%203-4%203-3v2l1%202v3c0%201%202%201%206-1h5l3-1c1-2%204-1%204%202l1-1%201-2v2c0%206-1%206-18%206H0v145a3962%203962%200%20002%209V48h398v52c0%2051%200%2051-2%2051-6%200-15%206-18%2013a5154%205154%200%2000-9%2012l-3%201-1%201-3%204c-3%204-4%204-6%203s-2%200-5%205l-4%209c0%204-3%205-10%206l-12%201h-4c-2-1-3-2-4-1l-3%201c-1%200-4%201-5%203-2%201-4%202-5%201-2%200-2%200-1-1v-1h-11c0-2%200-2-2-1h-7l-5%201-2%202v-3l-3%202c-1%201-1%201-1-1l-1-2-1%201c0%201-6%201-6-1l-1%201v4h8c3-1%204%200%202%202-2%201-1%204%201%204l2%201c0%202%203%204%205%203%203%200%208%204%208%206h7l3%201-3%201-5%202c-2%200-1%201%208%201%207%201%209%201%209-1l-1-1-5-1%202-1%203-1%202-1%202-1h-2c-3%200-5-1-3-4%201-1%203-1%202%201h9c1-1%201-1-1-3-3-2-3-3%201-3%202%200%202%200%201%201v1l1%202%202%203c1%201%201%201-1%201-4%200-7%201-8%203l-2%204v1c2%200%203%202%202%206-1%203%202%203%206%200%202-2%204-3%205-2h5c2%200%203%201%200%203-1%201%200%201%203%201%204-1%209-2%205-2-2%200-1-5%201-6l2-1%202-1-1%203c-3%203-3%205-1%204l2%201c-1%201%202%201%209%201h10v-5l3-6c1-1%201-1%201%204l-1%2015c1%2019%200%2023-5%2023l-3-2c0-3-3-3-11%201-6%203-6%204-6%207l2%205%202%203%202%208c2%208%205%2011%2011%2011%204%200%204%200%204%203l2%208%201%205h37V10H0v4m177%2019L65%2034c-2%202-2%208%201%2010l168%201h166V33h-53a6472%206472%200%2001-170%200M52%20103c-14%205-23%2017-23%2031-1%207%200%2011%203%2012h3l-3%201c-2%200-2%200%200%203l3%203%204%201-2%201h-3l3%204%203%203%204%203c7%206%2023%208%2033%203%205-2%2012-7%2012-9l-8-1c-2%200-3-1-3-2l-2-1c-2%201-2-1-1-4l3-4%201-2c0-1%201-2%203-2s3-1%203-2h2l4%202%201-1c-3-2-2-4%202-4%205%200%205-2%200-2l-3-1h3c5%200%205-3%201-12-3-8-5-11-11-12-3%200-4-1-4-2%200-4-1-5-6-7-7-1-15-1-22%201m74%2015l2%207c3%207%204%207%205%201%202-5%202-5%204%201%202%205%203%205%205-2l2-6c2-2%201-3-1-3l-2%201v6l-1%203-2-5c-2-6-3-6-5%201l-1%205-1-3v-6c0-2%200-2-3-2s-3%200-2%202m91%203c-3%200-3%200-2%202l1%205c-1%203-1%203%201%203s3-1%203-4l1-4v4c0%203%201%204%203%204s2%200%201-5l1-4%201%205c0%204%201%204%203%204s2%200%201-4l-1-5c-1-2-7-2-13-1m20%200l-3%201v14h2c3%200%203%200%202-1-2-2-1-4%201-4%203%200%205-2%205-6%200-2-3-6-4-5l-3%201m-184%201c3%202%201%2016-2%2018-2%201-3%203%200%203l3%202c2%201%202%201%205-1%204-2%205-3%203-5-2-1-4-9-4-14%201-4%200-5-1-3h-1l-2-1c-2%200-2%200-1%201m204%2017v2c0%202%200%202-2%202-3%200-6%206-4%209%201%202%2010%202%2010%200l-1-8c0-6%200-6-3-5m-186%202l-4%202h-2c-3%200-2%202%200%203h3c1-1%201-1%201%201%201%202%201%202-4%202l-5%202h3l4-1-3%202-3%202h-6c-4%201-9%200-9-2l-2-1v-1l2-1c2%200%203-2%202-5%200-2-1-2-6-2s-6%200-4%202l3%208c3%208%205%2013%208%2013l2%201h5c6%200%208-2%2012-9l7-17-4%201m86%2024l-1%201c-4-2-6%201-6%206v6c-3%203%206%205%209%202%202-3%200-5-3-5l-3-1c-1-1%200-1%201-1%203%200%205-2%205-5-1-1-1-2%201-2l1-2c-1-1-3-1-4%201m128%2071c0%203%200%203%2012%203l2%201h2c1-2%202-2%202-1h2l1%201h2c3-2%202-3-1-3-2%200-3%200-2-1%200-2-1-2-7-1l-8-1c-2-2-5-1-5%202m82%2049v1l-3%201-3%209%201%203%201-1%203-1c1%200%202%200%201%201l1%201c3-1%204-6%203-10s-1-5-4-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/e6c6a6c094162369c4feb0d6d39af7bf/ca0a1/9yvIsIG.webp 223w", "/static/e6c6a6c094162369c4feb0d6d39af7bf/75680/9yvIsIG.webp 445w", "/static/e6c6a6c094162369c4feb0d6d39af7bf/8d1ba/9yvIsIG.webp 890w", "/static/e6c6a6c094162369c4feb0d6d39af7bf/3838e/9yvIsIG.webp 1335w", "/static/e6c6a6c094162369c4feb0d6d39af7bf/211fa/9yvIsIG.webp 1716w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/e6c6a6c094162369c4feb0d6d39af7bf/e92b6/9yvIsIG.png 223w", "/static/e6c6a6c094162369c4feb0d6d39af7bf/e66bf/9yvIsIG.png 445w", "/static/e6c6a6c094162369c4feb0d6d39af7bf/4ef49/9yvIsIG.png 890w", "/static/e6c6a6c094162369c4feb0d6d39af7bf/4e814/9yvIsIG.png 1335w", "/static/e6c6a6c094162369c4feb0d6d39af7bf/adef7/9yvIsIG.png 1716w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/e6c6a6c094162369c4feb0d6d39af7bf/4ef49/9yvIsIG.png",
              "alt": "9yvIsIG",
              "title": "9yvIsIG",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Amazing.`}</p>
    <p>{`Lucky for us Microsoft is replacing the Edge browser engine with Chrome some time soon. Maybe then we won't need this anymore 🤞`}</p>
    <p>{`Cheers, ~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      